import axios from 'axios';

const apiClient = axios.create({
    baseURL: 'https://my-json-server.typicode.com/JohannesScr/MyJSONServer',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

export default {
    getEvents() {
        console.log('Loading Events data');
        return apiClient.get('/events');
    },
    getEvent(id) {
        console.log('Loading Event data');
        return apiClient.get(`/events/${id}`);
    }
};
